var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCm360Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    role: "img",
    "aria-label": "Campaign Manager 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Campaign Manager 360") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.68 34.6a4.75 4.75 0 0 1 -6.74 0l-7.12 7.11a14.93 14.93 0 0 0 21.1-21.1l-7.12 7.12a5 5 0 0 1 -.12 6.87z",
    fill: "#34a853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34.66 20.61a4.9 4.9 0 0 1 -6.87 0l-7.12 7.12a14.93 14.93 0 0 0 21.1-21.1l-7.12 7.12a4.9 4.9 0 0 1 0 6.87z",
    fill: "#5bb974"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41.9 6.63a14.93 14.93 0 0 0 -21.1 21.1l7.12-7.12a4.77 4.77 0 0 1 6.74-6.74 5.12 5.12 0 0 0 7.24-7.24z",
    fill: "#1e8e3e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m27.92 20.61a14.93 14.93 0 0 0 -21.1 21.1 5.5 5.5 0 0 0 7.74 0c2.12-2.12 1.62-5-.5-7.12a4.77 4.77 0 0 1 6.74-6.74 5 5 0 1 0 7.49-6.74 1.72 1.72 0 0 0 -.37-.5z",
    fill: "#5bb974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCm360Logo);
export default __webpack_public_path__ + "static/media/cm360-logo.de35753b89c41d0f584ed81e730019ca.svg";
export { ForwardRef as ReactComponent };